import React from 'react';
import { Icon } from './Icon.js';
export const IconFlag2Fill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m9.75,1H3v7h6.75c.689,0,1.25-.561,1.25-1.25V2.25c0-.689-.561-1.25-1.25-1.25Z", strokeWidth: "0", fill: "currentColor" }),
        React.createElement("path", { d: "m2.75,12c-.414,0-.75-.336-.75-.75V.75c0-.414.336-.75.75-.75s.75.336.75.75v10.5c0,.414-.336.75-.75.75Z", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" })));
};
//# sourceMappingURL=IconFlag2Fill12.js.map